'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Constants used for the dispatcher (actions) and flux store.
 */
var ADD_NOTIFICATION = exports.ADD_NOTIFICATION = 'ADD_NOTIFICATION';
var REMOVE_NOTIFICATION = exports.REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
var RESET_NOTIFICATIONS = exports.RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';

/**
 * Constants used to emit change events which are handled
 * by components.
 */
var DISPATCH_UPDATE = exports.DISPATCH_UPDATE = 'notification_update';